@if (model) {
    <div>
        @if (isBOGHelpBoxVisible) {
            <ms-bog-help class="best-odds-container" (closeClick)="onBOGHelpBoxClose()" />
        }
        @if (crmBannerPromotions.length) {
            <ms-crm-promotion-container [promotions]="crmBannerPromotions" />
        }
        <ms-next-races [nextFixtures]="nextFixtures" />
        @if (model.fixtures.length) {
            <ms-day-of-race-lobby [dayOfRace]="model" [filter]="today" [sportId]="sportId" />
        }
        @if (!model.fixtures.length) {
            <ms-error [links]="false" [message]="sitecore.horseRacing.tournaments.ErrNoTodayRaces" [severity]="'info'" />
        }
    </div>
}
